import { Chip } from "@mui/material";
import { PropTypes } from "prop-types";

import { getShortLabel } from "@/utils";

const TagItem = ({ getItemProps, hoverTimeoutRef, index, isHovered, option, setHoveredChip }) => {
    const fullLabel = option?.label || "";
    const shortLabel = getShortLabel(fullLabel);

    return (
        <Chip
            {...getItemProps({ index })}
            label={isHovered ? fullLabel : shortLabel}
            maxWidth={isHovered ? 220 : 90}
            onMouseEnter={() => {
                if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
                setHoveredChip(option?.value);
            }}
            onMouseLeave={() => {
                hoverTimeoutRef.current = setTimeout(() => setHoveredChip(null), 1000);
            }}
        />
    );
};

TagItem.propTypes = {
    getItemProps: PropTypes.func.isRequired,
    hoverTimeoutRef: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    isHovered: PropTypes.bool.isRequired,
    option: PropTypes.object.isRequired,
    setHoveredChip: PropTypes.func.isRequired,
};

export default TagItem;
